// extracted by mini-css-extract-plugin
export var animationContainer = "_i1-0";
export var asteriskIcon = "_i1-8";
export var conversationLeftSection = "_i1-4";
export var conversationListItem = "_i1-3";
export var conversationMiddleSection = "_i1-5";
export var conversationRightSection = "_i1-6";
export var detailsContent = "_i1-1";
export var listContainer = "_i1-7";
export var modalContent = "_i1-2";